<template>
	<div class="wine-list-wrapper">
		<curation-edit-color
			:change-curation-wine-color="changeCurationWineColor"
		/>

		<div
			class="wine-list-item"
			v-for="(wine, index) in editableWineList"
			:key="wine.id"
		>
			<div class="curation-wine-header">
				<layout-button-text
					class="remove-curation-wine-button"
					:callback="
						() => {
							deleteWine(index);
						}
					"
					:is-type="4"
				>
					<img :src="resources.removeIcon" class="remove-icon" />
				</layout-button-text>

				<p class="title">{{ index + 1 }}번</p>
			</div>

			<div class="divide-line"></div>

			<wine-view v-model="editableWineList[index]">
				<layout-button-text
					v-if="index !== 0"
					class="top-button"
					:callback="
						() => {
							move(index);
						}
					"
					:is-type="1"
					title="위로"
				/>

				<layout-button-text
					v-if="index !== editableWineList.length - 1"
					class="down-button"
					:callback="
						() => {
							move(index, false);
						}
					"
					:is-type="2"
					title="아래로"
				/>
			</wine-view>
		</div>

		<layout-button-text
			class="add-curation-wine-button"
			:callback="addWine"
			:is-type="1"
			title="추가"
		/>
	</div>
</template>

<script>
import _ from "lodash";
import removeIcon from "@/assets/icons/remove-button.svg";
import LayoutButtonText from "@/spa/components/LayoutButtonText";
import WineView from "./WineView";
import CurationEditColor from "./CurationEditColor";

export default {
	name: "WineListView",
	components: {
		WineView,
		LayoutButtonText,
		CurationEditColor
	},
	props: {
		value: Array
	},
	computed: {
		wines() {
			return this.wineList;
		}
	},
	methods: {
		changeCurationWineColor(name, hex) {
			this.editableWineList = this.editableWineList.map(curationWine => {
				const wine = curationWine;
				wine[name] = hex;

				return wine;
			});
		},

		addWine() {
			const tempId = -1 * this.createCnt;

			const isEmptyCurationWineList = this.editableWineList.length === 0;
			const emptyCurationWine = {
				id: tempId,
				wine_id: null,
				short_wine_name: "",
				curation_dsc: "",
				order_number: 0
			};

			const lastCurationWine =
				_.cloneDeep(this.editableWineList[this.editableWineList.length - 1]) ||
				null;
			if (lastCurationWine) lastCurationWine.id = tempId;

			this.editableWineList.push(
				isEmptyCurationWineList ? emptyCurationWine : lastCurationWine
			);
			this.createCnt += 1;

			this.$toast("새 큐레이션 와인을 추가하였습니다.");
		},

		deleteWine(index) {
			const result = this.editableWineList.filter(
				(curationWine, loopIndex) => index !== loopIndex
			);
			this.editableWineList = result;

			this.$toast(`'${index + 1}번' 큐레이션 와인 항목을 삭제하였습니다.`);
		},

		move(index, top = true) {
			const targetIdx = index + 1 + -2 * top;

			const swapTarget = _.cloneDeep(this.editableWineList[index]);

			this.$set(this.editableWineList, index, this.editableWineList[targetIdx]);
			this.$set(this.editableWineList, targetIdx, swapTarget);
		}
	},
	watch: {
		editableWineList(value) {
			this.$emit("input", value);
		},

		value(value) {
			this.editableWineList = value;
		}
	},
	data() {
		return {
			editableWineList: this.value,
			createCnt: 1,
			resources: {
				removeIcon
			}
		};
	}
};
</script>

<style lang="scss" scoped>
.wine-list-wrapper {
	width: 100%;
	height: 100%;

	.wine-list-item {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		align-content: flex-start;
		flex-direction: column;

		box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
		background-color: rgb(255, 255, 255);

		padding: 20px 10px 0 10px;

		margin-bottom: 16px;

		.divide-line {
			width: 90%;
			height: 1px;

			margin-top: 20px;
			margin-bottom: 20px;

			background-color: rgba(0, 0, 0, 0.1);
		}

		.curation-wine-header {
			width: 100%;

			display: flex;
			justify-content: flex-start;
			align-content: center;
			align-items: center;

			flex-direction: row;
			margin-bottom: 10px;
			padding: 0 10px;

			.remove-curation-wine-button {
				width: 20px;
				height: 20px;
				cursor: pointer;

				padding: 0;

				.remove-icon {
					width: 100%;
					height: 100%;
				}
			}

			.title {
				padding: 0;
				margin-left: 30px;
				font-size: 16px;
			}
		}
	}

	.add-curation-wine-button {
		width: 60px;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
		align-content: center;
	}
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/curation/detail-row/curation-wine-list/WineListView.vue